module.exports = __webpack_public_path__ + "img/cause1Orange.c41be759.png";